// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Store
import { NgxsModule } from '@ngxs/store';
import { ChatbotState } from './chatbot/chatbot.state';
// 3rd party
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
// Modules
import { SectionsReviewModule } from './sections-review/sections-review.module';
import { PhotoReviewModule } from './photo-review/photo-review.module';
import { OpenSchemaModule } from './open-schema/open-schema.module';
import { RulesModule } from './rule-engine/rules/rules.module';
// Component
import { HistoricalValuesComponent } from './historical-values/historical-values.component';
import { ConfirmationInactivityComponent } from './confirmation-inactivity/confirmation-inactivity.component';
import { TopNavigationMenuComponent } from './top-navigation-menu/top-navigation-menu.component';
import { FloatingSketchComponent } from './floating-sketch/floating-sketch.component';
import { InlineSketchComponent } from './inline-sketch/inline-sketch.component';

const COMPONENTS = [
	HistoricalValuesComponent,
	ConfirmationInactivityComponent,
	TopNavigationMenuComponent,
	FloatingSketchComponent,
	InlineSketchComponent
];

const MODULES = [
	SectionsReviewModule,
	PhotoReviewModule,
	OpenSchemaModule,
	RulesModule
];

@NgModule({
	declarations: [...COMPONENTS],
	entryComponents: [...COMPONENTS],
	imports: [
		CommonModule,
		CvComponentLibraryModule,
		...MODULES
	],
	exports: [
		...MODULES,
		...COMPONENTS
	],
})
export class ViewsModule { }
